import React from 'react';
import { Shield, MapPin, Clock, Award } from 'lucide-react';
import { credentials, companyInfo } from '../mockData';

const About = () => {
  return (
    <section id="about" style={{
      backgroundColor: '#edf2f7',
      padding: '120px 0'
    }}>
      <div className="container">
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
            Why Choose Us
          </h2>
          <p className="body-large" style={{ 
            color: 'var(--text-secondary)',
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Looking for professional process servers in California who deliver results you can depend on? We specialize in service of process, court filing, e-filing, and county recording with unmatched accuracy and speed. Law firms and self-represented parties trust us because:
          </p>
        </div>

        {/* Stats Section */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem',
          padding: '3rem',
          backgroundColor: 'var(--bg-page)',
          borderRadius: '12px',
          border: '1px solid var(--border-medium)'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div className="heading-1" style={{ 
              color: 'var(--brand-primary)',
              fontSize: '3rem',
              marginBottom: '0.5rem'
            }}>
              22+
            </div>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Years Experience
            </p>
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <div className="heading-1" style={{ 
              color: 'var(--brand-primary)',
              fontSize: '3rem',
              marginBottom: '0.5rem'
            }}>
              58
            </div>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              California Counties
            </p>
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <div className="heading-1" style={{ 
              color: 'var(--brand-primary)',
              fontSize: '3rem',
              marginBottom: '0.5rem'
            }}>
              24/7
            </div>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              E-Filing Available
            </p>
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <div className="heading-1" style={{ 
              color: 'var(--brand-primary)',
              fontSize: '3rem',
              marginBottom: '0.5rem'
            }}>
              100%
            </div>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Professional Service
            </p>
          </div>
        </div>

        {/* Trust & Credibility Section */}
        <div style={{
          backgroundColor: 'var(--bg-card)',
          padding: '3rem',
          borderRadius: '12px',
          border: '1px solid var(--border-medium)',
          marginBottom: '4rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h3 className="heading-2" style={{ marginBottom: '1rem', color: 'var(--text-primary)' }}>
              Trusted by California Legal Professionals
            </h3>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto' }}>
              Our reputation for reliability and professionalism has made us the preferred choice for law firms and legal professionals throughout California.
            </p>
          </div>

          {/* Trust Badges */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            <div style={{
              textAlign: 'center',
              padding: '1.5rem',
              backgroundColor: 'var(--bg-page)',
              borderRadius: '8px',
              border: '1px solid var(--border-light)'
            }}>
              <Shield size={32} color="var(--brand-primary)" style={{ marginBottom: '1rem' }} />
              <h4 className="heading-4" style={{ marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
                Registered & Bonded
              </h4>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Fully licensed and insured process servers in compliance with California law
              </p>
            </div>

            <div style={{
              textAlign: 'center',
              padding: '1.5rem',
              backgroundColor: 'var(--bg-page)',
              borderRadius: '8px',
              border: '1px solid var(--border-light)'
            }}>
              <Award size={32} color="var(--brand-primary)" style={{ marginBottom: '1rem' }} />
              <h4 className="heading-4" style={{ marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
                Law Firm Preferred
              </h4>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Trusted by law firms nationally for legal document services
              </p>
            </div>

            <div style={{
              textAlign: 'center',
              padding: '1.5rem',
              backgroundColor: 'var(--bg-page)',
              borderRadius: '8px',
              border: '1px solid var(--border-light)'
            }}>
              <Clock size={32} color="var(--brand-primary)" style={{ marginBottom: '1rem' }} />
              <h4 className="heading-4" style={{ marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
                Same-Day Service
              </h4>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Emergency service available when court deadlines are critical
              </p>
            </div>

            <div style={{
              textAlign: 'center',
              padding: '1.5rem',
              backgroundColor: 'var(--bg-page)',
              borderRadius: '8px',
              border: '1px solid var(--border-light)'
            }}>
              <MapPin size={32} color="var(--brand-primary)" style={{ marginBottom: '1rem' }} />
              <h4 className="heading-4" style={{ marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
                Statewide Coverage
              </h4>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Comprehensive service across all 58 California counties
              </p>
            </div>
          </div>

          {/* Professional Affiliations */}
          <div style={{ textAlign: 'center' }}>
            <h4 className="heading-4" style={{ marginBottom: '1.5rem', color: 'var(--text-primary)' }}>
              Professional Memberships & Certifications
            </h4>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: '2rem',
              fontSize: '0.9rem',
              color: 'var(--text-secondary)'
            }}>
              <span>• California Association of Legal Support Professionals (CALSPro)</span>
              <span>• National Association of Professional Process Servers (NAPPS)</span>
            </div>
          </div>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <Award size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              California Process Server Experts
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              Decades of hands-on experience serving legal documents throughout California.
            </p>
          </div>

          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <Clock size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              Fast & Reliable Service of Process
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              Same-day and rush service available to meet strict court deadlines.
            </p>
          </div>

          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <Shield size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              Complete Legal Support
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              From court filings to e-filings and county recordings, we handle every step with precision.
            </p>
          </div>

          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <MapPin size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              Local Knowledge, Statewide Reach
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              We know California courts, clerks, and recording offices—saving you time and preventing costly mistakes.
            </p>
          </div>

          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <Clock size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              Clear Client Communication
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              Real-time updates and responsive support keep you informed from start to finish.
            </p>
          </div>

          <div 
            style={{
              padding: '2rem',
              backgroundColor: 'var(--bg-page)',
              border: '1px solid var(--border-medium)',
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }}
            className="credential-card"
          >
            <div style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <Award size={24} color="white" />
            </div>
            
            <h3 className="heading-3" style={{
              marginBottom: '1rem',
              fontSize: '1.3rem'
            }}>
              Pride
            </h3>
            
            <p className="body-small" style={{
              color: 'var(--text-secondary)',
              lineHeight: '1.6'
            }}>
              Our team is very proud of the work we do. We strive for excellence in every assignment—whether it's a complex court filing, an urgent process serve, or a sensitive recording. Pride means holding ourselves accountable, delivering with precision, and earning the trust of every client we serve.
            </p>
          </div>
        </div>

        {/* Closing Statement */}
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem',
          padding: '2rem',
          backgroundColor: 'var(--bg-page)',
          borderRadius: '12px',
          border: '1px solid var(--border-medium)'
        }}>
          <p className="body-large" style={{
            color: 'var(--text-primary)',
            fontWeight: '600',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Choosing us means partnering with a California legal support service that puts efficiency, compliance, and reliability first.
          </p>
        </div>

        {/* Company Info Section */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '3rem',
          alignItems: 'center',
          padding: '3rem',
          backgroundColor: 'var(--bg-page)',
          borderRadius: '12px',
          border: '1px solid var(--border-medium)'
        }} className="company-info-grid">
          
          <div>
            <h3 className="heading-2" style={{ 
              marginBottom: '1.5rem',
              fontSize: '1.8rem'
            }}>
              Serving California Since 2003
            </h3>
            
            <p className="body-medium" style={{ 
              color: 'var(--text-secondary)',
              marginBottom: '1.5rem',
              lineHeight: '1.6'
            }}>
              With decades of experience serving law firms and self-represented parties, we've built a reputation for accuracy, reliability, and results. From urgent serves to complex filings, our specialists get it right the first time.
            </p>
            
            <p className="body-medium" style={{ 
              color: 'var(--text-secondary)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Whether you're a California law firm needing reliable process serving nationwide or a self-represented individual navigating court systems across the country, we're here to help with professional, timely service. All our process servers are registered in the jurisdictions where they operate.
            </p>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: 'var(--bg-card)',
              borderRadius: '8px',
              border: '1px solid var(--border-medium)'
            }}>
              <MapPin size={20} color="var(--brand-primary)" />
              <div>
                <p className="body-small" style={{ color: 'var(--text-primary)', marginBottom: '0.25rem' }}>
                  {companyInfo.address}
                </p>
                <p className="caption" style={{ color: 'var(--text-secondary)' }}>
                  {companyInfo.coverage}
                </p>
              </div>
            </div>
          </div>

          <div>
            <div style={{
              padding: '2rem',
              backgroundColor: 'var(--brand-primary)',
              borderRadius: '12px',
              textAlign: 'center',
              color: 'var(--text-inverse)'
            }}>
              <h4 style={{
                fontSize: '1.3rem',
                fontWeight: '600',
                marginBottom: '1rem',
                color: 'var(--text-primary)'
              }}>
                Registered and Bonded
              </h4>
              <p style={{
                fontSize: '1rem',
                color: 'var(--text-primary)',
                marginBottom: '1.5rem',
                opacity: 0.9
              }}>
                All our process servers are properly registered in the counties where they operate and fully bonded for your protection.
              </p>
              <Shield size={48} color="var(--text-inverse)" style={{ opacity: 0.8 }} />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .credential-card:hover {
          transform: translateY(-4px);
          background-color: var(--border-medium) !important;
        }

        @media (max-width: 767px) {
          .company-info-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default About;